var __jsx = React.createElement;
import dynamic from "next/dynamic";
import React, { useEffect } from "react";
import { PageLayout } from "../../util/constants";
import { observer } from "mobx-react-lite";
import Head from "next/head";
import { useStore } from "@dp/state";
import { useRouter } from "next/router";
import i18next from "i18next";
var MyAccount = dynamic(function () {
  return import("@dp/xcomp").then(function (mod) {
    return mod.MyAccount;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@dp/xcomp")];
    }
  }
});
var MyAccountPage = function MyAccountPage() {
  var _router$pathname, _store$user5, _router$query;
  var store = useStore();
  var router = useRouter();
  var isNewUser = router.query.isNewUser;
  var isSocialFlow = router.query.isSocialFlow;
  // # comes in url if user redirected from B2C login
  var activeTab = router === null || router === void 0 || (_router$pathname = router.pathname) === null || _router$pathname === void 0 ? void 0 : _router$pathname.split("/")[2];
  useEffect(function () {
    var _store$initComponent;
    store === null || store === void 0 || (_store$initComponent = store.initComponent("MyAccount")) === null || _store$initComponent === void 0 || _store$initComponent.then(function () {
      var _store$user, _store$user2, _store$user3;
      if (!(store !== null && store !== void 0 && (_store$user = store.user) !== null && _store$user !== void 0 && _store$user.isLoggedIn)) {
        // redirect to handle auth
        store === null || store === void 0 || store.platformUtil.navigateToRoute("/customer-service/handle-auth-urls");
      }
      store === null || store === void 0 || (_store$user2 = store.user) === null || _store$user2 === void 0 || (_store$user2 = _store$user2.userProfileModel) === null || _store$user2 === void 0 || _store$user2.setActiveTab(activeTab);
      store === null || store === void 0 || (_store$user3 = store.user) === null || _store$user3 === void 0 || (_store$user3 = _store$user3.analyticsModel) === null || _store$user3 === void 0 || _store$user3.dispatchPageViewEvent();
    });
  }, []);
  useEffect(function () {
    var _store$user4;
    if (isNewUser === "true" && store !== null && store !== void 0 && (_store$user4 = store.user) !== null && _store$user4 !== void 0 && _store$user4.isLoggedIn) {
      store.user.userProfileModel.showPreferredLocationSelectionAfterCreateAccount = true;
      // This will differentiate b/w the social and normal create account confirmation flow
      if (isSocialFlow === "true") {
        store.user.userProfileModel.isSocialFlow = true;
      }
      router.push({
        pathname: router.pathname
      }, undefined, {
        shallow: true
      });
    }
  }, [store === null || store === void 0 || (_store$user5 = store.user) === null || _store$user5 === void 0 ? void 0 : _store$user5.isLoggedIn]);
  return __jsx(React.Fragment, null, __jsx(Head, null, __jsx("title", null, i18next.t("title.myaccount.pagetitle", {
    defaultValue: "Account Profile"
  }))), __jsx(MyAccount, {
    isEditing: (router === null || router === void 0 || (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.isEditing) === "true"
  }));
};
MyAccountPage.layout = PageLayout.NB_LAYOUT;
MyAccountPage.layoutProps = {
  analyticsData: {
    pageName: "customer-service|account-profile",
    pageType: "customer-service",
    primaryCategory: "Account flow"
  }
};
export default observer(MyAccountPage);